// @ts-nocheck
import hoverAnimations from "@insite/mobius/Button/hoverAnimations";

Object.assign(hoverAnimations, {});
